export default __webpack_public_path__ + "static/analytics-5fc408dac21d18f913180984f6424bcf.png";